/** Unix seconds from WAHA → pt-BR list/thread time. */
export function formatWhatsAppInboxTimestamp(timestampSeconds: number): string {
  const date = new Date(timestampSeconds * 1000);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const now = new Date();
  if (date.toDateString() === now.toDateString()) {
    return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }

  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}
